import { Controller } from "@hotwired/stimulus"

// Fills the invoice due date from the selected payment term:
// due_date = invoice_date + the term's net_days. Fires when either the term or
// the invoice date changes. The field stays editable, so a user can still
// override it. Mirrors the server-side Invoice#assign_due_date fallback.
export default class extends Controller {
  static targets = [ "invoiceDate", "term", "dueDate" ];
  static values = { netDays: Object };

  declare readonly invoiceDateTarget: HTMLInputElement;
  declare readonly termTarget: HTMLSelectElement;
  declare readonly dueDateTarget: HTMLInputElement;
  declare readonly netDaysValue: Record<string, number>;

  recompute() {
    const termId = this.termTarget.value;
    const invoiceDate = this.invoiceDateTarget.value;
    if (!termId || !invoiceDate) return;

    const netDays = this.netDaysValue[termId];
    if (netDays === undefined || netDays === null) return;

    const [ year, month, day ] = invoiceDate.split("-").map(Number);
    if (!year || !month || !day) return;

    const due = new Date(year, month - 1, day);
    due.setDate(due.getDate() + netDays);

    const yyyy = due.getFullYear();
    const mm = String(due.getMonth() + 1).padStart(2, "0");
    const dd = String(due.getDate()).padStart(2, "0");
    this.dueDateTarget.value = `${yyyy}-${mm}-${dd}`;
  }
}
